var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pad-home"},[_c('HeaderBar',{attrs:{"title":"商家信息","showLeft":true}}),_c('div',{staticClass:"advertise-container"},[_c('iframe',{attrs:{"src":_vm.adUrl,"frameborder":"0","width":"100%","height":"100%"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }